import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Button, useMediaQuery } from "@material-ui/core";

const useStyles = makeStyles({

   dialog: {
    "& .MuiDialog-paperWidthSm": {
        borderRadius: "0.5rem",
        height: "auto",
        width: '700px',
        maxWidth: '700px'
    },
    "@media(max-width: 450px)": {
        "& .MuiDialog-paper": {
            minWidth: "90% !important",
        },
    },
},
btnConfirmar: {
    "&:hover": {
        backgroundColor: "#E4002B",
        color: "#fff",
    },
    backgroundColor: "#E4002B",
    color: "#fff",
    borderRadius: "24px",
    border: "1px solid #E4002B",
    height: "48px",
    width: "272px",
    "@media(max-width: 450px)": {
      width: "100% !important",
      marginRight: 0,
      marginTop: 40
    },
    marginRight: "16px",
    marginBottom: "16px"
}
});

const DialogModalGenerico = props => {
  const classes = useStyles();
  const matches = useMediaQuery('(min-width:550px)');
  const { title, handleClose, open, isMaintenance } = props
  
  const handleClick = (e) =>{
    e.preventDefault();
    handleClose();
  }

  const svgIconModal = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z" stroke="#282727" stroke-width="1.5" stroke-miterlimit="10"/>
    <path d="M24 15V25.5" stroke="#555353" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M26.2031 32.25C26.2031 33.4668 25.2168 34.4531 24 34.4531C22.7832 34.4531 21.7969 33.4668 21.7969 32.25C21.7969 31.0332 22.7832 30.0469 24 30.0469C25.2168 30.0469 26.2031 31.0332 26.2031 32.25Z" fill="#282727" stroke="#555353" stroke-width="0.0937499"/>
    </svg>
  )

  const svgCloseModal = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="#555353" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 6L18 18" stroke="#555353" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )

  const renderBeforeMaintenance = () => {
    return (
      <>
        <span style={{ color: '#555353',fontWeight: '400',fontSize: '16px',lineHeight: '150%', letterSpacing: '-1.9%'}}>
          Por tareas de mantenimiento, nuestros canales digitales no estarán disponibles desde el <b>viernes 20 a las 00</b> hasta el <b>sábado 21 de junio</b>.
        </span>
        <span style={{ color: '#555353',fontWeight: '400',fontSize: '16px',lineHeight: '150%', letterSpacing: '-1.9%', marginTop: '20px'}}>
          En caso de emergencia, podés comunicarte las 24 horas al <span style={{color: "#FF8200",textDecoration: "underline"}}>0810-888-3226</span>.
        </span>
        <span style={{ color: '#555353',fontWeight: '400',fontSize: '16px',lineHeight: '150%', letterSpacing: '-1.9%', marginTop: '20px'}}>
          ¡Gracias por tu comprensión!
        </span>
      </>
    );
  };

  const renderIsMaintenance = () => {
    return (
      <>
        <span style={{ color: '#555353', fontWeight: '400', fontSize: '16px', lineHeight: '150%', letterSpacing: '-1.9%' }}>
          Por tareas de mantenimiento, nuestros canales no están disponibles.
        </span>
        <span style={{ color: '#555353', fontWeight: '400', fontSize: '16px', lineHeight: '150%', letterSpacing: '-1.9%', marginTop: '20px' }}>
          Nuestras clínicas, guardias y la línea de emergencias siguen funcionando.
          <br/>
          <b>En caso de una emergencia, pueden comunicarte las 24 horas al 0810-888-3226.</b>
        </span>
        <span style={{ color: '#555353',fontWeight: '400',fontSize: '16px',lineHeight: '150%', letterSpacing: '-1.9%', marginTop: '20px'}}>
          Atenderemos las consultas administrativas cuando se recupere el servicio.
        </span>
      </>
    );
  };

  return <>
    <Dialog open={open}  className={classes.dialog}>
      <DialogContent style={{ textAlign: /* matches ? "left" : */ "center", color: "#000" }}>
        <DialogContentText style={{ color: "#000" }}>
            <div style={{
                display: 'flex',
                alignItems:/*  matches ? "left" : */ "center",  
                justifyContent: 'space-between', 
                position: 'relative', 
                padding: '10px 0px 10px 0px', 
                width: '100%' 
              }}>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '10px' }}>{svgIconModal}</div>
                <span style={{ 
                  color: '#555353', 
                  fontSize: '24px', 
                  lineHeight: '28px', 
                  fontWeight: '400',
                  textAlign: matches ? "center" : "left"
                }}>
                  {title}
                </span>
              </div>

              {matches ? <button
                onClick={handleClick}
                style={{
                  marginTop: '-20px',
                  background: "none",
                  border: "none",
                  cursor: "pointer"
                }}
              >
                {svgCloseModal}
              </button> : <br/>}

            </div>
            <br/>
            <div style={{ display: "flex", flexDirection: "column", textAlign: 'start' }}>
              {
                isMaintenance 
                  ? renderIsMaintenance()
                  : renderBeforeMaintenance()
              }
            </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{justifyContent: matches ? "flex-end" : "center"}}>
        <Button
          className={classes.btnConfirmar}
          style={{ fontSize: '14px', textTransform: "none", backgroundColor: "#FF8200", border: "1px solid #FF8200", color: "#fff" }}
          onClick={(e) => {
            handleClick(e);
          }}
          color='primary'>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  </>
};

export default DialogModalGenerico;